import * as React from 'react'
import { gsap } from '~/lib/gsap'

export const useDialogSteps = () => {
  const [activeStepIndex, setActiveStepIndex] = React.useState<number>(0)
  const wrapperRef = React.useRef<HTMLDivElement>(null)

  React.useEffect(() => {
    if (!wrapperRef.current) return

    const steps = wrapperRef.current?.children ?? []
    const step = steps?.[activeStepIndex] as HTMLElement
    const nonActiveSteps = Array.from(steps).filter(
      (el) => el !== step
    ) as HTMLElement[]

    if (step) {
      const wrapperPaddingBlock = window
        .getComputedStyle(wrapperRef.current)
        .getPropertyValue('padding-block')
      const wrapperPaddingBlockInPx = parseFloat(wrapperPaddingBlock)
      const wrapperPaddingInline = window
        .getComputedStyle(wrapperRef.current)
        .getPropertyValue('padding-inline')
      const wrapperPaddingInlineInPx = parseFloat(wrapperPaddingInline)

      step.style.removeProperty('display')
      const firstStepFocusableChildWithAutoFocus = step.querySelector(
        '[autofocus], button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      ) as HTMLElement
      if (firstStepFocusableChildWithAutoFocus) {
        firstStepFocusableChildWithAutoFocus.focus()
      }
      gsap.fromTo(
        wrapperRef.current,
        { height: wrapperRef.current.offsetHeight },
        {
          height: wrapperPaddingBlockInPx * 2 + step.offsetHeight,
          duration: 0.3,
          ease: 'power2.inOut',
          onStart: () => {
            nonActiveSteps.forEach((el) => {
              el.style.transitionDelay = '0s'
              el.style.transition = 'opacity 0.25s'
              el.style.position = 'absolute'
              el.style.width = `calc(100% - ${wrapperPaddingInlineInPx * 2}px)`
              el.style.pointerEvents = 'none'
              el.style.opacity = '0'
              setTimeout(() => {
                el.style.display = 'none'
              }, 200)
            })
            step.style.transition = 'opacity 0.25s'
            step.style.transitionDelay = '0.18s'
            step.style.position = 'relative'
            step.style.opacity = '1'
            step.style.pointerEvents = 'auto'
          },
        }
      )
    }
  }, [activeStepIndex])

  const initialStylesForInactiveSteps: React.CSSProperties = {
    opacity: '0',
    position: 'absolute',
    display: 'none',
  }
  return {
    initialStylesForInactiveSteps,
    wrapperRef,
    activeStepIndex,
    setActiveStepIndex,
  }
}
